var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.012 6.49974C15.249 -0.227265 0.742011 -0.215265 0.988011 6.49974H15.012ZM2.09901 5.49974C3.08201 1.46274 12.959 1.47374 13.906 5.49974H2.09901ZM1.27101 9.67074L0.730011 8.82874L2.22201 7.86974C2.84501 7.46874 3.82301 7.46974 4.44601 7.86974C4.97401 8.23174 5.58701 8.67874 6.23801 8.28774C7.06401 7.64674 8.14701 7.26274 9.11201 7.87074L9.76301 8.28774C10.416 8.67874 11.026 8.23274 11.555 7.86974C12.178 7.46874 13.156 7.46974 13.779 7.86974L15.271 8.82874L14.73 9.67074L13.238 8.71174C12.939 8.51874 12.395 8.51874 12.096 8.71174L11.446 9.12974C10.48 9.73374 9.39701 9.35374 8.57101 8.71174C8.27101 8.51874 7.72801 8.51974 7.43001 8.71174C6.60601 9.35574 5.51401 9.73373 4.55501 9.13073L3.90501 8.71274C3.60701 8.51974 3.06301 8.51974 2.76301 8.71274L1.27101 9.67174V9.67074ZM1.00001 10.4997C0.941011 11.9857 1.37101 14.4137 4.00001 14.4997H12C14.632 14.4127 15.055 11.9877 15 10.4997H1.00001ZM13.956 11.4997C13.843 12.2307 13.438 13.4997 12 13.4997H4.00001C2.57101 13.4997 2.16301 12.2307 2.04701 11.4997H13.956Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBurger);
export default __webpack_public_path__ + "static/media/ico_burger.759f2d575064de316240d1d82dc67a23.svg";
export { ForwardRef as ReactComponent };